var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d, _e, _f, _g;
import { Expose } from 'class-transformer';
export class ModelSearchConnectedUser {
    model;
    fileName;
    title;
    formatDate;
    date;
    country;
    owner;
    location;
    author;
    fitness;
    depository;
    archivalSymbol;
    stockageRef;
    commentaries;
    additionalDetails;
}
__decorate([
    Expose(),
    __metadata("design:type", typeof (_a = typeof TAutocompleteOption !== "undefined" && TAutocompleteOption) === "function" ? _a : Object)
], ModelSearchConnectedUser.prototype, "model", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelSearchConnectedUser.prototype, "fileName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelSearchConnectedUser.prototype, "title", void 0);
__decorate([
    Expose(),
    __metadata("design:type", typeof (_b = typeof TAutocompleteOption !== "undefined" && TAutocompleteOption) === "function" ? _b : Object)
], ModelSearchConnectedUser.prototype, "formatDate", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelSearchConnectedUser.prototype, "date", void 0);
__decorate([
    Expose(),
    __metadata("design:type", typeof (_c = typeof TAutocompleteOption !== "undefined" && TAutocompleteOption) === "function" ? _c : Object)
], ModelSearchConnectedUser.prototype, "country", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelSearchConnectedUser.prototype, "owner", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelSearchConnectedUser.prototype, "location", void 0);
__decorate([
    Expose(),
    __metadata("design:type", typeof (_d = typeof TAutocompleteOption !== "undefined" && TAutocompleteOption) === "function" ? _d : Object)
], ModelSearchConnectedUser.prototype, "author", void 0);
__decorate([
    Expose(),
    __metadata("design:type", typeof (_e = typeof TAutocompleteOption !== "undefined" && TAutocompleteOption) === "function" ? _e : Object)
], ModelSearchConnectedUser.prototype, "fitness", void 0);
__decorate([
    Expose(),
    __metadata("design:type", typeof (_f = typeof TAutocompleteOption !== "undefined" && TAutocompleteOption) === "function" ? _f : Object)
], ModelSearchConnectedUser.prototype, "depository", void 0);
__decorate([
    Expose(),
    __metadata("design:type", typeof (_g = typeof TAutocompleteOption !== "undefined" && TAutocompleteOption) === "function" ? _g : Object)
], ModelSearchConnectedUser.prototype, "archivalSymbol", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelSearchConnectedUser.prototype, "stockageRef", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelSearchConnectedUser.prototype, "commentaries", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelSearchConnectedUser.prototype, "additionalDetails", void 0);
